import { createSlice } from "@reduxjs/toolkit";
import { getState } from "@bd-stores/store";

/**
 * @type {BD_StoreGameProgress}
 */
const initialState = {
    players: [],
    finalTeamAnswers: {},
    teamAnswers: {},
    roomStatus: {},
    allRoomCompleted: false,
    isFinished: false,
    isMiddleState: false,
    leader: 0,
    selectedCase: 0,
};

const gameProgressSlice = createSlice({
    name: "gameProgress",
    initialState,
    reducers: {
        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['players']>} action
         */
        setPlayers: (state, action) => ({
            ...state,
            players: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['finalTeamAnswers']>} action
         */
        setFinalTeamAnswers: (state, action) => ({
            ...state,
            finalTeamAnswers: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['teamAnswers']>} action
         */
        setTeamAnswers: (state, action) => ({
            ...state,
            teamAnswers: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['roomStatus']>} action
         */
        setRoomStatus: (state, action) => ({
            ...state,
            roomStatus: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['allRoomCompleted']>} action
         */
        setAllRoomCompleted: (state, action) => ({
            ...state,
            allRoomCompleted: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['isFinished']>} action
         */
        setFinished: (state, action) => ({
            ...state,
            isFinished: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['isMiddleState']>} action
         */
        setIsMiddleState: (state, action) => ({
            ...state,
            isMiddleState: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['leader']>} action
         */
        setLeader: (state, action) => ({
            ...state,
            leader: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['selectedCase']>} action
         */
        setSelectedCase: (state, action) => ({
            ...state,
            selectedCase: action.payload,
        }),
    },
});

export const getRoomStatus = (roomId) => {
    const roomStatus = getState().gameProgress.roomStatus;
    return roomStatus?.[roomId] || "is-status-open";
};

export const getFinalTeamAnswers = (roomId) => {
    const finalTeamAnswers = getState().gameProgress.finalTeamAnswers;
    return finalTeamAnswers?.[roomId] || false;
};

export const getTeamAnswers = (roomId) => {
    const teamAnswers = getState().gameProgress.teamAnswers;
    return teamAnswers?.[roomId] || false;
};

export const getPlayers = () => {
    const players = getState().gameProgress.players;
    return players ?? [];
};

export const getLeader = () => {
    const playerID = getState().gameProgress.leader;
    return playerID ?? 0;
}

export const getSelectedCase = () => {
    const selectedCaseID = getState().gameProgress.selectedCase;
    return selectedCaseID ?? 0;
}

export const getUserFromId = (userId) => {
    const players = getState().gameProgress.players;
    const user = players.find((p) => p.userId === userId);
    return user;
};

export const {
    setPlayers,
    setTeamAnswers,
    setFinalTeamAnswers,
    setRoomStatus,
    setAllRoomCompleted,
    setFinished,
    setIsMiddleState,
    setLeader,
    setSelectedCase,
} = gameProgressSlice.actions;
export const gameProgress = gameProgressSlice.reducer;
